import { render, staticRenderFns } from "./DebitHistory.vue?vue&type=template&id=67648949&"
import script from "./DebitHistory.vue?vue&type=script&lang=js&"
export * from "./DebitHistory.vue?vue&type=script&lang=js&"
import style0 from "./DebitHistory.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports